const isPackageLicensePlate = require('./isPackageLicencePlate');
const isWaybillNumber = require('./isWaybillNumber');

module.exports = function decideSearchType(value = '') {
    if(isPackageLicensePlate(value))
        return 'kollinr';
    if(isWaybillNumber(value))
        return 'frbrnr';
    return 'ref';
}